module.exports = __webpack_public_path__ + "static/caversham-fddccf8aaa2971a0fcddaedbefca4104.jpg";